import { useState } from 'react'
import ProductStockPanel from './components/ProductStockPanel'
import { StockStoreType } from './context'
import { StockStoreTypeEnum } from './config'

export default function Inventory() {
  const [activeTab, setActiveTab] = useState(StockStoreTypeEnum[0])
  return (
    <StockStoreType.Provider value={{ stockStoreType: activeTab }}>
      <ProductStockPanel type={activeTab} setActiveTab={setActiveTab} />
    </StockStoreType.Provider>
  )
}
